module.exports = __webpack_public_path__ + "img/8.d854b156.png";